import { Resource as w, API as $ } from "@coveo/platform-client";
import { withDelay as s, getMockAgent as b, createMockAgentFromRequest as z, addMockAgent as U, updateMockAgent as D, deleteMockAgent as I, getMockAgentStore as S } from "./AgentConfigurationResource.mocks.js";
import { shouldMockAgentConfiguration as l } from "./ShouldMockAgentConfiguration.js";
const d = 2e3, i = class i extends w {
  /**
   * List agents with optional pagination and sorting.
   *
   * GET /preview/organizations/{organizationId}/agents
   *
   * @param {AgentListOptions} options The list options.
   * @param {MockResponseParams} mockingParams Optional mocking parameters.
   */
  list(e, t) {
    return l(this.api.organizationId, t == null ? void 0 : t.isMocking) ? s(this.createMockListResponse(e), d) : this.api.get(this.buildPath(i.baseUrl, e));
  }
  /**
   * Get a single agent by ID.
   *
   * GET /preview/organizations/{organizationId}/agents/{agentId}
   *
   * @param {string} agentId The agent ID.
   * @param {MockResponseParams} mockingParams Optional mocking parameters.
   */
  get(e, t) {
    if (l(this.api.organizationId, t == null ? void 0 : t.isMocking)) {
      const r = b(e);
      return r ? s(r, d) : Promise.reject(new Error(`Agent with ID ${e} not found`));
    }
    return this.api.get(`${i.baseUrl}/${e}`);
  }
  /**
   * Create a new agent.
   *
   * POST /preview/organizations/{organizationId}/agents
   *
   * @param {CreateAgentRequest} agent The agent data.
   * @param {MockResponseParams} mockingParams Optional mocking parameters.
   */
  create(e, t) {
    if (l(this.api.organizationId, t == null ? void 0 : t.isMocking)) {
      const r = z(e);
      return U(r), s(r, d);
    }
    return this.api.post(i.baseUrl, e);
  }
  /**
   * Update an existing agent (PATCH).
   *
   * PATCH /preview/organizations/{organizationId}/agents/{agentId}
   *
   * Note: followUpEnabled and agentType are NOT modifiable.
   *
   * @param {string} agentId The agent ID.
   * @param {UpdateAgentRequest} agent The updated agent data.
   * @param {MockResponseParams} mockingParams Optional mocking parameters.
   */
  update(e, t, r) {
    if (l(this.api.organizationId, r == null ? void 0 : r.isMocking)) {
      const n = D(e, t);
      return n ? s(n, d) : Promise.reject(new Error(`Agent with ID ${e} not found`));
    }
    return this.api.patch(`${i.baseUrl}/${e}`, t);
  }
  /**
   * Delete an agent.
   *
   * DELETE /preview/organizations/{organizationId}/agents/{agentId}
   *
   * @param {string} agentId The agent ID.
   * @param {MockResponseParams} mockingParams Optional mocking parameters.
   */
  delete(e, t) {
    return l(this.api.organizationId, t == null ? void 0 : t.isMocking) ? I(e) ? s(void 0, d) : Promise.reject(new Error(`Agent with ID ${e} not found`)) : this.api.delete(`${i.baseUrl}/${e}`);
  }
  /**
   * Creates a mock list response with proper pagination.
   */
  createMockListResponse(e) {
    const t = S(), r = (e == null ? void 0 : e.page) ?? 1, n = (e == null ? void 0 : e.perPage) ?? 25, o = [...t];
    e != null && e.sortingType && o.sort((M, p) => {
      const A = M[e.sortingType], a = p[e.sortingType], h = String(A ?? "").localeCompare(String(a ?? ""));
      return e.sortingOrder === "DSC" ? -h : h;
    });
    const c = (r - 1) * n, f = o.slice(c, c + n), g = Math.ceil(t.length / n);
    return {
      pagination: {
        page: r,
        perPage: n,
        totalItems: t.length,
        totalPages: g
      },
      items: f
    };
  }
};
i.baseUrl = `/preview/organizations/${$.orgPlaceholder}/agents`;
let u = i;
export {
  u as AgentConfigurationResource
};
//# sourceMappingURL=AgentConfigurationResource.js.map
